import * as React from 'react';
import {
  Col,
  Row,
  Navbar,
  Nav,
  Button,
  Card,
} from 'react-bootstrap';
import Select from 'react-select-emotionless';
import MapWithExport from './MapWithExport';
import MapComponents from './business-objects/MapComponents';
import { SnappingStatus } from './business-objects/Enums';
import MapUtils from './Utils/MapUtils';
import StringUtils from './Utils/StringUtils';
import {
  ICoordinates,
} from './business-objects/AlacrityInterfaces';
import './css/esri-map.css';
import WindowPortal from './WindowPortal';
import LocationExtended from './business-objects/ExtendedLocation';
import { ICoordinatesExtended } from './business-objects/ExtendedCoordinates';
import { ILocationData } from './business-objects/LocationData';
import Api from '../../../../services/Api';
import { ApiResponse } from 'apisauce';
import * as urls from '../../../shared/urls';
import { LocationWorkflowStepName } from '../../../WorkflowQueues/Location/presentation/config';
import { getTableValuesByGroupName } from '../../../../services/Utils/IndexedDBUtils';
import { Multiselect } from 'multiselect-react-dropdown';
import { eValueType } from '../../../WorkflowQueues/Location/presentation/LocationEntry';
import { eLocationUserType } from '../../../../common/sharedTypes';
import LocalStorageUtils from '../../../WorkflowQueues/common/LocalStorageUtils';
import styled from 'styled-components';

export interface MapComponentProps {
  component: any;
  form: any;
  reportId?: number;
  currentUserId?: number;
  openNow?: boolean;
}

interface IntersectionData {
  number: string;
  street1: string;
  street2: string;
  description: string;
  distance: number;
  latitiude: number;
  longitude: number;
}

export interface MapPopupState {
  showModal: boolean;
  selectedLocation: LocationExtended;
  temporaryLocation: LocationExtended;
  lastMapCenters: ICoordinates;
  mapComponents: MapComponents;
  saveDisabled: boolean;
  appContext: any;
  mapData: ILocationData[];
  reportId: number;
  nearestIntersections: IntersectionData[];
  nearestCity: any[];
  bridgeDetails: any[];
  pinDropped: boolean;
  streetName: string;
  privateProperty: boolean;
  selectedCity: string;
  selectedCityName: string;
  locationValue: string;
  editLocation: boolean;
  showLocationError: boolean;
  keepExistingSpot: boolean;
  unknownLocation: boolean;
  intersectionRealted: boolean;
  nearestRoadData: any[];
  currentMapItem: ILocationData;
  locationEdited: boolean;
}

export default class MapComponentReact extends React.Component<
  MapComponentProps,
  MapPopupState
> {
  appContextWatcher: any;
  constructor(props: MapComponentProps) {
    super(props);
    this.state = {
      showModal: props.openNow || false,
      selectedLocation: null,
      temporaryLocation: null,
      lastMapCenters: null,
      mapComponents: null,
      saveDisabled: false,
      appContext: {
        internetStatus: 'ONLINE',
        webServiceStatus: 'ONLINE',
        currentSkin: null,
        defaultLocation: null,
        currentUserId: 1,
        applicationId: 2,
        currentFormIdentifier: '',
      },
      mapData: [],
      reportId: 0,
      nearestIntersections: [],
      nearestCity: [],
      bridgeDetails: [],
      pinDropped: false,
      streetName: '',
      privateProperty: false,
      selectedCity: '',
      selectedCityName: '',
      locationValue: '',
      editLocation: false,
      showLocationError: false,
      keepExistingSpot: false,
      unknownLocation: false,
      intersectionRealted: false,
      nearestRoadData: [],
      currentMapItem: {
        createdById: this.props.form.options.mapConfig.currentUserId,
        createdDate: new Date().toISOString(),
        modifiedById: this.props.form.options.mapConfig.currentUserId,
        modifiedDate: new Date().toISOString(),
        latitude: 0,
        longitude: 0,
        enteredById: this.props.form.options.mapConfig.currentUserId,
        isVisible: true,
        userTypeId: this.props.form.options.mapConfig.userTypeId,
        crashReportId: this.props.form.options.mapConfig.crashReportId,
        id: 0,
        reportId: 0,
        routeId: null,
        measure: null,
        relatedIntersection: '',
        skipMeasureDetails: false,
        bridgeName: '',
        nearestCity: '',
        direction: '',
        locationLine: '',
        intersectionId: '0',
        primaryRoad: '',
        routeNumber1: '',
        secondaryRoad: '',
        routeNumber2: '',
      },
      locationEdited: false,
    };
  }
  windowRef: WindowPortal;
  skipNightlyProcess: any;
  skippedNightlyProcess: any;
  relatedIntersectionRef: any;
  bridgeDropdownRef: any;
  locationRef: any;
  navDirections: any = ['N', 'E', 'S', 'W'];

  /* 
   * For testing
   *
  tempData = [
    {latitude: 40.813720, longitude: -96.724313},
    {latitude: 40.813716, longitude: -96.725043},
    {latitude: 40.814025, longitude: -96.724901}
  ]
  */

  onOpenClick = () => {
    this.setState({ showModal: true });
  };

  onClosingClick = () => {
    if (this.windowRef?.externalWindow) {
      const {
        screenLeft,
        screenTop,
        innerWidth,
        innerHeight
      } = this.windowRef?.externalWindow;
      const size = `width=${innerWidth},height=${innerHeight},left=${screenLeft},top=${screenTop}`;
      LocalStorageUtils.setLocalStorageItem("mapItScreenSize", size);
    }

    (this.state.mapComponents.view as any).destroy();
    this.setState({ showModal: false });
  };

  onCancel = () => {
    this.setState({
      temporaryLocation: null,
      selectedLocation: null,
      unknownLocation: false,
    }, () => {
      this.disableAndClearData();
      this.onClosingClick();
    });
  };

  onSave = () => {
    let currentMapItem = this.state.currentMapItem;
    if (currentMapItem != null) {
      currentMapItem.locationLine = this.getLocationLine();
      this.updateLocationEntryInfo();
      this.props.form.options.mapConfig.onSaveValue(
        currentMapItem,
        this.state.privateProperty,
        this.state.unknownLocation
      );

      if (currentMapItem.skipMeasureDetails) {
        this.props.form.options.mapConfig.setRecordValue(
          'routeNumber',
          '',
          eValueType.CorrectedValue
        );
      }
    }

    this.props.form.options.mapConfig.setCorrectedValueEditability('streetName', currentMapItem.skipMeasureDetails);

    this.setState({ selectedLocation: this.state.temporaryLocation }, () => {
      this.onClosingClick();
    });
  };

  updateLocationEntryInfo = () => {
    let currentMapItem = this.state.currentMapItem;
    this.props.form.options.mapConfig.setRecordValue(
      'streetName',
      this.state.streetName,
      eValueType.CorrectedValue
    );
    this.props.form.options.mapConfig.setRecordValue(
      'locationLine',
      this.getLocationLine(),
      eValueType.CorrectedValue
    );
    this.props.form.options.mapConfig.setRecordValue(
      'ownership',
      this.state.privateProperty ? '02' : '01',
      eValueType.CorrectedValue
    );
  };

getLocationLine = () => {
  if (this.state.locationValue !== '' && this.state.locationEdited) {
    return this.state.locationValue;
  } else {
    const localMapItem = this.state.currentMapItem;
    const selectedCity = this.state.nearestCity.find(
      (a) => a.name === localMapItem.nearestCity
    );

    // keep intersection lookup (if needed elsewhere)
    let intersectionDescription = '';
    if (
      localMapItem.relatedIntersection &&
      this.state.nearestIntersections &&
      this.state.nearestIntersections.length > 0
    ) {
      const matchingIntersectionListItem = this.state.nearestIntersections.find(
        (item) => item.number === localMapItem.relatedIntersection
      );
      intersectionDescription = matchingIntersectionListItem
        ? matchingIntersectionListItem.description
        : '';
    }

    // intersectionRelated removed from the logic
    let locationLine = this.state.unknownLocation
      ? 'Unknown Location'
      : this.state.privateProperty
        ? 'Private Property'
        : localMapItem.primaryRoad +
          ' (' +
          localMapItem.routeNumber1 +
          ') ' +
          localMapItem.bridgeName +
          ' ' +
          (localMapItem.direction
            ? localMapItem.direction.split(',').join(' & ') + ' OF '
            : '') +
          localMapItem.secondaryRoad +
          ' (' +
          localMapItem.routeNumber2 +
          ')' +
          (selectedCity ? ' NEAR ' + selectedCity.description : '');

      locationLine = locationLine
        .replace(/\(\)/g, '')
        .replace(/\s{2,}/g, ' ')
        .trim()
        .toLocaleUpperCase();

    return locationLine;
  }
};


  /*
  mapDataToForm = (location: LocationExtended) => {
    let countyCode = "Lancaster";
    let cityCode = "Lincoln";

    let fieldNames = (this.props.component.mapOptions || []).map(option => option.formComponent);
    let locationProperties = (this.props.component.mapOptions || []).map(option => option.locationProperty);

    for (const fieldNameIndex in fieldNames) {
      const fieldName = fieldNames[fieldNameIndex];
      const locationProperty = locationProperties[fieldNameIndex];
      const formComponent = ComponentUtils.getComponent(this.props.form, fieldName);
      const formValue =
        locationProperty == "countyCode"
          ? countyCode
          : locationProperty == "cityCode"
          ? cityCode
          : location[locationProperty];
      if (formComponent) formComponent.setValue(formValue);
    }
  };
*/

  mapBuilt = (mapComponents: MapComponents) => {
    this.setState({
      mapComponents: mapComponents,
      temporaryLocation: this.state.selectedLocation,
    });

    this.initializeWithPreviousValues(mapComponents);
    //this.initializeCenterZoom(mapComponents);

    let lastLocation: LocationExtended = new LocationExtended();
    mapComponents.onCenterPointUpdated((longitude, latitude, zoomLevel) => {
      if (
        longitude != lastLocation.longitude ||
        latitude != lastLocation.latitude ||
        zoomLevel != lastLocation.zoomLevel
      ) {
        lastLocation = { ...lastLocation, longitude, latitude, zoomLevel };

        const centerPoint = {
          coordinates: {
            latitude: lastLocation.latitude,
            longitude: lastLocation.longitude,
          },
          zoomLevel: lastLocation.zoomLevel,
        };

        this.setState({
          lastMapCenters: centerPoint.coordinates,
          temporaryLocation: lastLocation,
        });
      }
    });

    const minZoom = this.props.component.minimumZoom || 15;

    mapComponents.view.on('click', async (event) => {
      if (mapComponents.view.zoom < minZoom) {
        mapComponents.view.zoom = mapComponents.view.zoom + 1;
        mapComponents.view.center = event.mapPoint;
      } else {
        event.stopPropagation();

        // Search for graphics at the clicked location
        const response = await mapComponents.view.hitTest(event);
        mapComponents.view.mileMarkerPost = null;
        mapComponents.view.rampRoute = '';
        if (response.results.length) {
          const results = response.results.filter(
            (result) =>
              // check if the graphic belongs to the layer of interest
              result.graphic.layer === mapComponents.view.mileMarkerLayer ||
              result.graphic.layer === mapComponents.view.rampLayer
          );

          const graphic = results && results.length && results[0].graphic;

          if (graphic && graphic.attributes && graphic.attributes.PostNumber) {
            mapComponents.view.mileMarkerPost = graphic.attributes.PostNumber;
          }

          if (graphic && graphic.attributes && graphic.attributes.RouteNumber) {
            mapComponents.view.mileMarkerRoute = graphic.attributes.RouteNumber;
          }

          if (graphic && graphic.attributes && graphic.attributes.ROUTE_NAME) {
            mapComponents.view.rampRoute = graphic.attributes.ROUTE_NAME;
          }
        }

        this.mapClicked(event.mapPoint);
      }
    });

    const stateRestriction = 'NE'; //this.props.component.stateRestrictionWhenSearching.value;

    const searchResultHasState = (result) =>
      result.feature.attributes.RegionAbbr === stateRestriction;
    const countryRestriction = this.props.component
      .countryRestrictionWhenSearching;

    if (stateRestriction) {
      const updateNumResults = (event) =>
      (event.numResults = event.results.reduce(
        (total: number, currentValue: any) =>
          total + currentValue.results.length,
        0
      ));

      mapComponents.searchWidget.on('suggest-complete', (event) => {
        event.results.forEach(
          (result) =>
          (result.results = result.results.filter((innerResult) =>
            innerResult.text.includes(stateRestriction)
          ))
        );
        updateNumResults(event);
      });

      mapComponents.searchWidget.on('search-complete', (event) => {
        event.results.forEach(
          (result) =>
            (result.results = result.results.filter(searchResultHasState))
        );
        updateNumResults(event);

        if (event.numResults) {
          const coordinates: ICoordinates = {
            latitude: event.results[0].results[0].feature.geometry.latitude,
            longitude: event.results[0].results[0].feature.geometry.longitude,
          };
          mapComponents.view.center = coordinates;
        }
      });
    } else {
      mapComponents.searchWidget.autoSelect = true;
    }

    if (countryRestriction) {
      mapComponents.locator.countryCode = countryRestriction;
    }
  };

  firstLocationWithLatLong = (locations: any[]) => {
    return locations.find(
      (mapItem) => mapItem.latitude != null && mapItem.longitude != null
    );
  };

  initializeWithPreviousValues = (mapComponents: MapComponents) => {
    let tempLocation: LocationExtended = new LocationExtended();
    let firstLocation = this.firstLocationWithLatLong(
      this.props.form.options.mapConfig.defaultLocations
    );
    let mapData = !!firstLocation
      ? firstLocation
      : this.props.form.options.mapConfig.defaultFocusLocation;
    tempLocation = {
      ...tempLocation,
      ...{ latitude: mapData.latitude, longitude: mapData.longitude },
    };

    const { defaultLocations } = this.props.form.options.mapConfig;
    // Carry the "Bypass NDOT LRS Process" value forward from the spot mapping
    // pin. We must read it explicitly from the spot mapping location
    // (userTypeId === SpotMapping) rather than the last element of the array,
    // because defaultLocations also contains the investigator pin (whose
    // skipMeasureDetails is always true) and may contain a review pin.
    if (defaultLocations && defaultLocations.length > 1) {
      const spotMappingLocation = defaultLocations.find(
        (location) =>
          location.userTypeId === eLocationUserType.SpotMapping
      );
      if (spotMappingLocation) {
        this.setMapValue({
          skipMeasureDetails: spotMappingLocation.skipMeasureDetails,
        });
      }
    }

    mapComponents.setMultipoints(
      this.props.form.options.mapConfig.defaultLocations,
      this.props.form.options.mapConfig.currentUserId
    );

    getTableValuesByGroupName('City').then((results) =>
      this.setState({ nearestCity: results })
    );

    getTableValuesByGroupName('BridgeRailroadRamp').then((results) =>
      this.setState({ bridgeDetails: results })
    );

    this.setState(
      {
        streetName: this.props.form.options.mapConfig.getRecordValueByKey(
          'streetName'
        ),
        privateProperty: this.props.form.options.mapConfig.privateProperty,
        unknownLocation: this.props.form.options.mapConfig.unknownLocation,
      },
      () => {
        if (this.state.unknownLocation || this.state.privateProperty) {
          this.disableAndClearData(this.state.privateProperty);
          this.locationRef.value = this.getLocationLine();
        }
      }
    );

    mapComponents.view.zoom = 15;
    this.setState(
      {
        temporaryLocation: tempLocation,
        mapData: this.props.form.options.mapConfig.defaultLocations,
        reportId: (firstLocation) ? firstLocation.caseID : this.props.form.options.mapConfig.reportId,
      },
      () => {
        let currentQueuePinInfo = this.state.mapData.find(
          (a) =>
            a.userTypeId ==
            (this.props.form.options.mapConfig.locationQueue ==
              LocationWorkflowStepName.Review
              ? 3
              : 2)
        );
        if (currentQueuePinInfo && this.props.form.options.mapConfig.userTypeId !== eLocationUserType.Administrator) {
          currentQueuePinInfo.reportId =
            this.state && this.state.reportId ? this.state.reportId : 0;
          this.setState({ currentMapItem: currentQueuePinInfo });
        }
      }
    );
  };

  initializeCenterZoom = (mapComponents: MapComponents) => {
    let selectedLocation: LocationExtended = this.state.selectedLocation;

    this.setState({ temporaryLocation: selectedLocation });

    if (!selectedLocation.longitude || !selectedLocation.latitude) {
      selectedLocation = { ...selectedLocation };

      //if (this.hasAddressCandidate(selectedLocation)) {
      //  this.retrieveCoordinatesFromLocation(selectedLocation, mapComponents);
      //}

      let defaultLocation: any = {
        latitude: 40.772061,
        longitude: -96.699607,
        zoomLevel: 20,
      };

      if (
        defaultLocation &&
        (!selectedLocation.cityCode ||
          selectedLocation.cityCode == defaultLocation.cityCode) &&
        (!selectedLocation.countyCode ||
          selectedLocation.countyCode == defaultLocation.countyCode)
      ) {
        selectedLocation.longitude = defaultLocation.longitude;
        selectedLocation.latitude = defaultLocation.latitude;
        selectedLocation.zoomLevel = defaultLocation.zoomLevel;
      } else {
        const lastCenter: ICoordinates = this.state.lastMapCenters;
        if (lastCenter) {
          selectedLocation.longitude = lastCenter.longitude;
          selectedLocation.latitude = lastCenter.latitude;
        } else if (
          this.props.component.defaultCenterPoint.defaultLongitude.length > 0 &&
          this.props.component.defaultCenterPoint.defaultLatitude.length > 0
        ) {
          selectedLocation.longitude = Number(
            this.props.component.defaultCenterPoint.defaultLongitude
          );
          selectedLocation.latitude = Number(
            this.props.component.defaultCenterPoint.defaultLatitude
          );
        } else {
          this.retrieveCoordinatesFromBrowser(mapComponents);
        }
      }
    } else {
      mapComponents.setGraphic(selectedLocation, null);

      if (selectedLocation.streetName) {
        const node = document.createElement('div');

        mapComponents.popup.open({
          title: '',
          location: new mapComponents.point(selectedLocation),
          content: node,
        });
      }
    }

    if (!selectedLocation.zoomLevel) {
      selectedLocation.zoomLevel = MapUtils.getDefaultZoom(
        selectedLocation,
        this.props.component.minimumZoom
      );
    }

    mapComponents.view.center = selectedLocation;
    mapComponents.view.zoom = selectedLocation.zoomLevel;
  };

  /*
  buildLocationFromForm = (): LocationExtended => {
    const location = new LocationExtended();
    const mapOptions = this.props.component.mapOptions || [];
    let fieldNames = mapOptions.map(option => option.formComponent);
    let locationProperties = mapOptions.map(option => option.locationProperty);

    if (!fieldNames) {
      return location;
    }

    for (const fieldNameIndex in fieldNames) {
      const fieldName = fieldNames[fieldNameIndex];
      const locationProperty = locationProperties[fieldNameIndex];
      const component = ComponentUtils.getComponent(this.props.form, fieldName);
      let value = component ? component.getValue() : "";
      location[locationProperty] = value;
    }

    if (!location.countyName && location.countyCode) {
      let county = "Lancaster";

      if (county) {
        location.countyName = county;
      }
    }

    if (!location.cityName && location.cityCode) {
      let city = "Lincoln";

      if (city) {
        location.cityName = city;
      }
    }

    if (!location.stateCode && location.stateName) {
      location.stateCode = stateCodes.getStateCodeByStateName(location.stateName);
    }

    if ((location.countyName || location.cityName) && !location.stateCode) {
      location.stateCode = this.props.component.stateRestrictionWhenSearching;
    }

    if (!location.stateName && location.stateCode) {
      location.stateName = stateCodes.getStateNameByStateCode(location.stateCode);
    }

    return location;
  };
*/

  hasAddressCandidate = (location: LocationExtended): boolean => {
    return StringUtils.anyHasValue(
      location.cityName,
      location.stateCode,
      location.countyName
    );
  };

  /*
  retrieveCoordinatesFromLocation = (selectedLocation: LocationExtended, mapComponents: MapComponents): void => {
    const error = (ex: Error) => {
      console.error(ex);
    };
    MapUtils.findAddressCandidates(
      selectedLocation,
      this.props.component.externalApiUrl,
      this.state.appContext.currentUserId,
      this.state.appContext.applicationId
    )
      .then(coordinates => {
        if (coordinates) {
          const zoomLevel = MapUtils.getDefaultZoom(selectedLocation);
          mapComponents.view.center = coordinates;
          mapComponents.view.zoom = zoomLevel;

          const centerPoint = {
            coordinates: coordinates,
            zoomLevel: zoomLevel
          };

          selectedLocation.zoomLevel = centerPoint.zoomLevel;

          this.setState({ lastMapCenters: centerPoint.coordinates, temporaryLocation: selectedLocation });
        }
      })
      .catch(error);
  };
  */

  retrieveCoordinatesFromBrowser = (mapComponents: MapComponents): void => {
    MapUtils.getCurrentPosition().then((coordinates) => {
      if (coordinates) {
        mapComponents.view.center = coordinates;
        this.setState({ lastMapCenters: coordinates });
      }
    });
  };

  mapClicked = (coordinates, snappedToRoadway?) => {
    coordinates = {
      latitude: coordinates.latitude,
      longitude: coordinates.longitude,
    };

    const mapComponents: MapComponents = this.state.mapComponents;
    const oldLocation: LocationExtended = this.state.temporaryLocation;

    const afterSnap =
      snappedToRoadway == SnappingStatus.snapSucceeded ||
      snappedToRoadway == SnappingStatus.snapFatal ||
      snappedToRoadway == SnappingStatus.snapFailed;

    const location: LocationExtended = afterSnap
      ? { ...oldLocation }
      : {
        ...new LocationExtended(),
        notOnRoadway: oldLocation.notOnRoadway,
        atIntersection: oldLocation.atIntersection,
        zoomLevel: oldLocation.zoomLevel,
        latitude: coordinates.latitude,
        longitude: coordinates.longitude,
      };

    // clear location if about to snap
    if (!afterSnap) {
      this.setState({ temporaryLocation: location });
    }

    mapComponents.removeGraphic();
    mapComponents.view.center = coordinates;
    mapComponents.popup.open({
      title: '',
      content: 'Loading...',
      location: new mapComponents.point(coordinates),
    });

    if (
      ((this.props.component.snapToRoadway && !location.notOnRoadway) ||
        location.atIntersection) &&
      !afterSnap
    ) {
      this.snapToRoadway(coordinates, location, snappedToRoadway);
    } else {
      this.locatePoint(
        coordinates,
        mapComponents,
        location,
        snappedToRoadway,
        coordinates.x,
        coordinates.y
      );
    }
  };

  snapToRoadway = (
    coordinates: ICoordinates,
    location: LocationExtended,
    snappedToRoadway: SnappingStatus
  ): void => {
    const onFailedSnap = () => {
      const snappedToRoadway: SnappingStatus = SnappingStatus.snapIfAvailable
        ? SnappingStatus.snapFailed
        : SnappingStatus.snapFatal;
      this.mapClicked(coordinates, snappedToRoadway);
    };

    const snapError = (ex: Error) => {
      const snappedToRoadway = SnappingStatus.snapFatal;
      this.mapClicked(coordinates, snappedToRoadway);
      console.error(ex);
    };

    const clickOnSnap = (coordinates: ICoordinates | any) => {
      const snappedToRoadway = SnappingStatus.snapSucceeded;
      this.mapClicked(coordinates, snappedToRoadway);
    };

    if (location.atIntersection) {
      MapUtils.getIntersectionData(
        { latitude: coordinates.latitude, longitude: coordinates.longitude },
        this.props.component.externalApiUrl,
        this.state.appContext.currentUserId,
        this.state.appContext.applicationId
      )
        .then((intersection) => {
          if (intersection) {
            location.bearing = intersection.bearing;
            location.distanceFromIntersection =
              intersection.distanceFromIntersection;
            location.intersectStreetName = intersection.street2;

            this.setState({ temporaryLocation: location });

            clickOnSnap(intersection);
          } else {
            onFailedSnap();
          }
        })
        .catch(snapError);
    } else {
      MapUtils.snapToRoadway(
        { latitude: coordinates.latitude, longitude: coordinates.longitude },
        this.props.component.externalApiUrl,
        this.state.appContext.currentUserId,
        this.state.appContext.applicationId
      )
        .then((adjustedCoordinates) => {
          if (adjustedCoordinates) {
            clickOnSnap(adjustedCoordinates);
          } else {
            onFailedSnap();
          }
        })
        .catch(snapError);
    }
  };

  locatePoint = (
    clickedCoordinates: ICoordinatesExtended,
    mapComponents: MapComponents,
    lastLocation: LocationExtended,
    snappedToRoadway: SnappingStatus,
    xCoord: Number,
    yCoord: Number
  ) => {
    if (
      snappedToRoadway === SnappingStatus.snapFatal &&
      !lastLocation.notOnRoadway
    ) {
      mapComponents.popup.open({
        title: 'No Roadway Found',
        content:
          'No roadway was found at this location, please click on a roadway.',
        location: new mapComponents.point(clickedCoordinates),
      });

      const selectedLocation = {
        ...(lastLocation as LocationExtended),
        longitude: clickedCoordinates.longitude,
        latitude: clickedCoordinates.latitude,
        snappedToRoadway: false,
      };
      this.setState({ temporaryLocation: selectedLocation });

      return;
    }

    let mapCoordsChanged = {
      longitude: Number(clickedCoordinates.longitude.toPrecision(10)),
      latitude: Number(clickedCoordinates.latitude.toPrecision(10)),
    };

    this.setMapValue(mapCoordsChanged);

    let pointToRemove = new Object({
      latitude: clickedCoordinates.latitude,
      longitude: clickedCoordinates.longitude,
    });
    mapComponents.setGraphic(clickedCoordinates, pointToRemove);

    mapComponents.popup.open({
      title: '',
      location: new mapComponents.point(clickedCoordinates),
      content: 'Loading...',
    });

    this.setState({ pinDropped: true });
    this.loadPinRelatedData(true);

    const logEvent = new CustomEvent('location-updated', {
      detail: { location: clickedCoordinates, reportId: this.props.reportId },
    });
    document.dispatchEvent(logEvent);

    const onFailure = () => {
      mapComponents.popup.open({
        title: '',
        location: new mapComponents.point(clickedCoordinates),
        content: 'No address found for this location.',
      });

      const selectedLocation: LocationExtended = {
        ...new LocationExtended(),
        longitude: clickedCoordinates.longitude,
        latitude: clickedCoordinates.latitude,
        zoomLevel: lastLocation.zoomLevel,
        notOnRoadway: lastLocation.notOnRoadway,
        snappedToRoadway: snappedToRoadway === SnappingStatus.snapSucceeded,
      };

      this.setState({ temporaryLocation: selectedLocation });
    };

    const locatorPromise: Promise<any> =
      lastLocation.notOnRoadway &&
      mapComponents.locator.locationToAddress(
        new mapComponents.point(clickedCoordinates),
        2000
      );

    const selectedLocation: LocationExtended = {
      ...new LocationExtended(),
      referencePostInfo: null,
      longitude: Number(clickedCoordinates.longitude.toPrecision(10)),
      latitude: Number(clickedCoordinates.latitude.toPrecision(10)),
      zoomLevel: lastLocation.zoomLevel,
      notOnRoadway: lastLocation.notOnRoadway,
      snappedToRoadway: snappedToRoadway === SnappingStatus.snapSucceeded,
    };

    this.setState({ temporaryLocation: selectedLocation });

    mapComponents.popup.close();
  };

  updateLayout = () => {
    let mapComponents = this.state.mapComponents;

    if (this.state.mapComponents && this.state.mapComponents.map) {
      mapComponents.map.basemap = this.state.appContext.currentSkin.isNightMode
        ? 'dark-gray-vector'
        : 'streets-vector';
    }

    this.setState({ mapComponents: mapComponents });
  };

  contextChanged = (appContext: any) => {
    this.setState({ appContext }, () => {
      this.updateLayout();
    });
  };

  setMapValue = (kvObject) => {
    this.setState({ locationEdited: kvObject.bypassChecked || false }, () => {
      let localMapItem = this.state.currentMapItem;
      let newMap = this.state.mapData.filter((a) =>
        a.userTypeId !=
        (this.props.form.options.mapConfig.locationQueue ==
          LocationWorkflowStepName.Review
          ? 3
          : 2)
      );

      Object.keys(kvObject).forEach((key) => {
        localMapItem[key] = kvObject[key];
      });
      localMapItem.modifiedDate = new Date().toISOString();
      localMapItem.modifiedById = this.props.currentUserId;
      localMapItem.userTypeId = this.props.form.options.mapConfig.userTypeId;
      if (!kvObject.locationLine)
        localMapItem.locationLine = this.getLocationLine();

      newMap.push(localMapItem);

      // set pin dropped when coordinates change so dropdowns will be enabled
      let pinDropped = this.state.pinDropped;
      if (!pinDropped && kvObject.latitude && kvObject.longitude) pinDropped = true;

      this.setState({
        mapData: newMap,
        currentMapItem: localMapItem,
        locationValue: localMapItem.locationLine,
        intersectionRealted: localMapItem.relatedIntersection !== '',
        pinDropped
      }, () => {
        if (pinDropped && this.state.nearestIntersections?.length === 0) {
          this.loadPinRelatedData(true);
        }
      });
    });
  };

  loadPinRelatedData = (loadCity?: boolean) => {
    this.loadDropDownDataIntoProperty(
      urls.GET_RELATED_ROADWAY_DATA,
      'nearestRoadData'
    );
    this.loadDropDownDataIntoProperty(
      urls.GET_NEAREST_INTERSECTIONS,
      'nearestIntersections'
    );

    if (loadCity) {
      setTimeout(() => this.setCityDropdown(), 1000);
    }
  };

  loadDropDownDataIntoProperty = (url, propertyName: string) => {
    let latLong: any;

    let webMercators = this.state.mapComponents.webMercatorUtils.lngLatToXY(
      this.state.currentMapItem.longitude,
      this.state.currentMapItem.latitude
    );

    latLong = {
      Latitude: this.state.currentMapItem.latitude,
      Longitude: this.state.currentMapItem.longitude,
      X: webMercators[1],
      Y: webMercators[0],
    };

    Api.post(url, latLong).then((response: ApiResponse<any>) => {
      let propToUpdate = {};
      propToUpdate[propertyName] = response.ok ? response.data : [];
      this.setState(propToUpdate);
    });
  };

  setCityDropdown = () => {
    const requestLatitude = this.state.currentMapItem.latitude;
    const requestLongitude = this.state.currentMapItem.longitude;
    let latLong: any;
    latLong = {
      Latitude: requestLatitude,
      Longitude: requestLongitude,
    };

    Api.post(urls.GET_CITY_BY_LAT_LONG, latLong).then(
      (response: ApiResponse<any>) => {
        if (response.ok) {
          const { currentMapItem } = this.state;
          const isSameCoordinateRequest =
            currentMapItem.latitude === requestLatitude &&
            currentMapItem.longitude === requestLongitude;

          // Ignore stale responses when the pin has moved since this request started.
          if (!isSameCoordinateRequest) return;

          // Do not overwrite a city selected by the user while request was in-flight.
          if (currentMapItem.nearestCity) return;

          let nearCity = this.state.nearestCity.find(
            (a) => a.description == response.data
          );
          if (!nearCity) return;

          let updatedCityData = {
            nearestCity: nearCity.name,
          };
          this.setMapValue(updatedCityData);
          this.setState({
            selectedCity: nearCity.description,
            selectedCityName: nearCity.name,
          });
        }
      }
    );
  };

  getDirectionValues = () => {
    return this.state.currentMapItem.direction != ''
      ? this.state.currentMapItem.direction.split(',')
      : [];
  };

  setDirectionValues = (selectedlist, selectedItem) => {
    if (!this.state.privateProperty && !this.state.unknownLocation) {
      let directionValues = {
        direction:
          (this.state.currentMapItem.direction.length > 0
            ? this.state.currentMapItem.direction + ','
            : '') + selectedItem,
      };

      this.setMapValue(directionValues);
    }
  };

  removeDirectionValues = (selectedList, removedItem) => {
    if (!this.state.privateProperty && !this.state.unknownLocation) {
      let dataArr =
        this.state.currentMapItem.direction != ''
          ? this.state.currentMapItem.direction.split(',')
          : [];
      dataArr.splice(dataArr.indexOf(removedItem), 1);

      let directionValues = {
        direction: dataArr.join(','),
      };

      this.setMapValue(directionValues);
    }
  };

  locationChangeEvent = (ev) => {
    if (ev.currentTarget.value.length <= 100)
      this.setState({
        locationValue: ev.currentTarget.value,
        locationEdited: true,
      });
    else
      this.setState({ showLocationError: true }, () => {
        setTimeout(() => this.setState({ showLocationError: false }), 5000);
      });
  };

  setKeepExistingSpot = () => {
    let newMapPoint = {
      ...this.state.mapData.find(
        (item) =>
          item.userTypeId ==
          (this.props.form.options.mapConfig.locationQueue ==
            LocationWorkflowStepName.Review
            ? 2
            : 1)
      )
    };
    newMapPoint.createdById = this.props.form.options.mapConfig.currentUserId;
    newMapPoint.createdDate = new Date().toISOString();
    newMapPoint.enteredById = this.props.form.options.mapConfig.currentUserId;
    newMapPoint.id = 0;

    if (
      this.props.form.options.mapConfig.locationQueue ==
      LocationWorkflowStepName.SpotMapping
    ) {
      newMapPoint.direction = '';
      newMapPoint.relatedIntersection = '';
      newMapPoint.primaryRoad = '';
      newMapPoint.routeNumber1 = '';
      newMapPoint.secondaryRoad = '';
      newMapPoint.routeNumber2 = '';
      newMapPoint.skipMeasureDetails = false;
      newMapPoint.bridgeName = '';
      newMapPoint.nearestCity = '';
      newMapPoint.locationLine = '';
      newMapPoint.intersectionId = '0';

      this.setState({
        pinDropped: false,
        unknownLocation: false,
        intersectionRealted: false,
      });
    }

    this.state.mapComponents.setGraphic(
      {
        longitude: Number(newMapPoint.longitude.toPrecision(10)),
        latitude: Number(newMapPoint.latitude.toPrecision(10)),
      } as ICoordinatesExtended,
      {
        longitude: this.state.currentMapItem.longitude,
        latitude: this.state.currentMapItem.latitude,
      }
    );
    this.setMapValue(newMapPoint);
  };

  setLocationUnknown = () => {
    this.setState(
      { unknownLocation: !this.state.unknownLocation, privateProperty: false },
      () => {
        this.setState({
          locationValue: this.state.unknownLocation ? 'Unknown Location' : '',
        });
        if (this.state.unknownLocation) this.disableAndClearData();
      }
    );
    this.setMapValue({
      latitude: 43,
      longitude: -95,
    });
  };

  disableAndClearData = (setPrivateProperty?: boolean, skipLRS: boolean = true) => {
    let mapUpdates = {
      skipMeasureDetails: skipLRS,
      direction: '',
      intersectionId: '0',
      primaryRoad: '',
      routeNumber1: '',
      secondaryRoad: '',
      routeNumber2: '',
      bridgeName: '',
      nearestCity: '',
    };

    this.props.form.options.mapConfig.setRecordValue(
      'ownership',
      setPrivateProperty ? '02' : '01',
      eValueType.CorrectedValue
    );
    this.props.form.options.mapConfig.setRecordValue(
      'streetName',
      '',
      eValueType.CorrectedValue
    );
    this.props.form.options.mapConfig.setRecordValue(
      'routeNumber',
      '',
      eValueType.CorrectedValue
    );
    this.props.form.options.mapConfig.setRecordValue(
      'referencePost',
      '',
      eValueType.CorrectedValue
    );
    this.setMapValue(mapUpdates);
  };

  render() {
    const intersectionRelatedOptions = [{ label: 'Not at an intersection', value: '' }].concat(
      this.state.nearestIntersections.map(i => {
        return {
          value: i.number,
          label: i.description,
        }
      })
    );

    const primaryRoadOptions = this.state.nearestRoadData.map(
      (i) => {
        return {
          value: i.number,
          label: i.description,
        }
      }
    );

    const roadwayFeaturesOptions = this.state.bridgeDetails.map((i) => {
      return {
        value: i.name,
        label: i.description
      }
    });

    const secondaryRoadOptions = this.state.nearestRoadData.map(
      (i) => {
        return {
          value: i.number,
          label: i.description,
        }
      }
    );

    const cityOptions = this.state.nearestCity.map((i) => {
      return {
        value: i.name,
        label: i.description,
      };
    });

    const mapItWindowSize = LocalStorageUtils.getLocalStorage("mapItScreenSize");

    return (
      <React.Fragment>
        <button
          className='btn btn-default'
          onClick={this.onOpenClick}
          style={{
            margin: 0,
            padding: 0,
            width: '100%',
            height: 50,
            whiteSpace: 'normal',
            lineHeight: '100%',
          }}
          key='showMapPopupButton'
        >
          {this.props.component.mapItButtonText}
        </button>

        {this.state.showModal && (
          <WindowPortal
            ref={(el) => {
              this.windowRef = el;
            }}
            closeWindowPortal={this.onClosingClick}
            title={this.props.component.title}
            moveFromElement='.esri-layer-list'
            moveToElement='.mapLayerVisibilityController'
            size={mapItWindowSize}
          >
            <div className='container-fluid'>
              <Row>
                <Col md={8}>
                  <div style={{ position: 'relative' }}>
                    <MapWithExport
                      mapContainerClassName='esri-view-popup'
                      component={this.props.component}
                      onReady={this.mapBuilt}
                      nightMode={false}
                    />
                    <div
                      className='mapLayerVisibilityController'
                      style={{ position: 'absolute', top: 10, left: 35 }}
                    />
                  </div>
                </Col>
                <Col
                  md={4}
                  style={{
                    position: 'relative',
                    paddingRight: '50px',
                  }}
                >
                  <span
                    className='glyphicon glyphicon-floppy-disk'
                    aria-hidden='true'
                    style={{ position: 'absolute', right: -45, fontSize: 25 }}
                    title='Save current map settings as my default'
                  ></span>
                  <Row>
                    <React.Fragment>
                      {this.state.temporaryLocation && (
                        <React.Fragment>
                          <Col>
                            <Row>
                              <Col>
                                <Card style={{ marginTop: 5 }}>
                                  <Card.Header style={{ fontSize: 12 }}>Location Description</Card.Header>
                                  <Card.Body style={{ fontSize: 12 }}>
                                    <div>
                                      <input
                                        type='checkbox'
                                        id='chkKeepExistingSpot'
                                        name='chkKeepExistingSpot'
                                        onClick={() => this.setKeepExistingSpot()}
                                        disabled={
                                          this.state.unknownLocation ||
                                          this.state.privateProperty
                                        }
                                      />{' '}
                                      Keep Existing Spot
                                    </div>
                                    <div>
                                      <input
                                        type='checkbox'
                                        ref={(el) =>
                                          (this.skippedNightlyProcess = el)
                                        }
                                        disabled={
                                          this.state.unknownLocation ||
                                          this.state.privateProperty
                                        }
                                        checked={
                                          this.state.currentMapItem
                                            .skipMeasureDetails
                                        }
                                        onClick={() =>
                                          this.setMapValue({
                                            skipMeasureDetails: !this.state
                                              .currentMapItem.skipMeasureDetails,
                                            bypassChecked: true,
                                          })
                                        }
                                      />{' '}
                                      Bypass NDOT LRS Process
                                    </div>
                                    <div style={{ marginTop: 10 }}>
                                      <input
                                        type='checkbox'
                                        id='chkPrivateProperty'
                                        name='chkPrivateProperty'
                                        disabled={this.state.unknownLocation}
                                        checked={this.state.privateProperty}
                                        onClick={() =>
                                          this.setState(
                                            {
                                              privateProperty: !this.state
                                                .privateProperty,
                                            },
                                            () => this.disableAndClearData(true, this.state.privateProperty)
                                          )
                                        }
                                      />{' '}
                                      Private Property
                                    </div>
                                    <div>
                                      <input
                                        type='checkbox'
                                        id='chkUnknownLocation'
                                        name='chkUnknownLocation'
                                        disabled={this.state.privateProperty}
                                        checked={this.state.unknownLocation}
                                        onClick={() => this.setLocationUnknown()}
                                      />{' '}
                                      Unknown Location
                                    </div>
                                    <div style={{ marginTop: 10 }}>
                                      <input
                                        type='checkbox'
                                        id='chkIntersectionRelated'
                                        name='chkPIntersectionRelated'
                                        disabled={
                                          this.state.unknownLocation ||
                                          this.state.privateProperty
                                        }
                                        checked={this.state.intersectionRealted}
                                        onClick={() =>
                                          this.setState(
                                            {
                                              intersectionRealted: !this.state
                                                .intersectionRealted,
                                            },
                                            () => {
                                              if (!this.state.intersectionRealted)
                                                this.setMapValue({
                                                  intersectionId: '0',
                                                  bypassChecked: true
                                                });
                                            }
                                          )
                                        }
                                      />{' '}
                                      Intersection Related
                                    </div>
                                    <React.Fragment>
                                      <label className='dveLabel'>
                                        intersecting road
                                      </label>
                                      <Select
                                        isDisabled={
                                          this.state.privateProperty ||
                                          this.state.unknownLocation ||
                                          !this.state.intersectionRealted ||
                                          !this.state.pinDropped ||
                                          this.state.nearestIntersections
                                            .length < 1
                                        }
                                        onChange={(e) => {
                                          this.setMapValue({
                                            relatedIntersection:
                                              e?.value || '',
                                              bypassChecked: true
                                          });
                                        }
                                        }
                                        ref={(el) =>
                                          (this.relatedIntersectionRef = el)
                                        }
                                        value={
                                          intersectionRelatedOptions.find(o => o.value === this.state.currentMapItem.relatedIntersection)
                                        }
                                        isClearable={true}
                                        options={
                                          intersectionRelatedOptions
                                        }
                                      />
                                    </React.Fragment>
                                    <h6 style={{ fontSize: 12 }}>Not an intersection:</h6>
                                    <label className='dveLabel'>
                                      primary road
                                    </label>
                                    <Select
                                      isDisabled={
                                        this.state.unknownLocation ||                                    
                                        this.state.privateProperty ||
                                        !this.state.pinDropped
                                      }
                                      onChange={(e) => {
                                        this.setMapValue({
                                          primaryRoad: e?.label || '',
                                          routeNumber1: e?.value || '',
                                        })
                                      }}
                                      value={
                                        primaryRoadOptions.find(o => o.value === this.state.currentMapItem.routeNumber1)
                                      }
                                      options={primaryRoadOptions}
                                      isClearable
                                    />
                                    <label className='dveLabel'>
                                      route number 1
                                    </label>
                                    <input
                                      type='text'
                                      className='spotDetailsInputs'
                                      value={this.state.currentMapItem.routeNumber1.length > 0 ?
                                        '(' + this.state.currentMapItem.routeNumber1 + ')'
                                        : ''
                                      }
                                      disabled
                                    />
                                    <label className='dveLabel'>
                                      roadway features
                                    </label>
                                    <Select
                                      isDisabled={
                                        this.state.unknownLocation ||
                                        this.state.privateProperty ||
                                        !this.state.pinDropped
                                      }
                                      onChange={(e) =>
                                        this.setMapValue({
                                          bridgeName: e?.value || '',
                                        })
                                      }
                                      options={roadwayFeaturesOptions}
                                      value={
                                        roadwayFeaturesOptions.find(o => o.value === this.state.currentMapItem.bridgeName)
                                      }
                                      isClearable
                                    />
                                    <label className='dveLabel'>
                                      direction
                                    </label>
                                    <Multiselect
                                      options={this.navDirections} // Options to display in the dropdown
                                      onSelect={this.setDirectionValues} // Function will trigger on select event
                                      onRemove={this.removeDirectionValues} // Function will trigger on remove event
                                      isObject={false}
                                      selectionLimit={2}
                                      selectedValues={this.state.currentMapItem.direction != "" ? this.state.currentMapItem.direction.split(',') : []}
                                      disable={
                                        this.state.unknownLocation ||
                                        this.state.privateProperty ||
                                        !this.state.pinDropped
                                      }
                                      avoidHighlightFirstOption={true}
                                    />
                                    <label className='dveLabel'>
                                      Secondary road
                                    </label>
                                    <Select
                                      isDisabled={
                                        this.state.unknownLocation ||
                                        this.state.privateProperty ||
                                        !this.state.pinDropped
                                      }
                                      onChange={(e) => {
                                        console.log({ e })
                                        this.setMapValue({
                                          secondaryRoad: e?.label || '',
                                          routeNumber2: e?.value || '',
                                        })
                                      }}
                                      value={
                                        secondaryRoadOptions.find(o => o.value === this.state.currentMapItem.routeNumber2)
                                      }
                                      options={secondaryRoadOptions}
                                      isClearable
                                    />
                                    <label className='dveLabel'>
                                      route number 2
                                    </label>
                                    <input
                                      type='text'
                                      className='spotDetailsInputs'
                                      value={this.state.currentMapItem.routeNumber2.length > 0 ?
                                        '(' + this.state.currentMapItem.routeNumber2 + ')'
                                        : ''
                                      }
                                      disabled
                                    />
                                    <h6 style={{ marginBottom: 0, fontSize: 12 }}>Near:</h6>
                                    <label className='dveLabel'>city</label>
                                    <Select
                                      isDisabled={
                                        this.state.unknownLocation ||
                                        this.state.privateProperty ||
                                        !this.state.pinDropped
                                      }
                                      onChange={(e) =>
                                        this.setMapValue({
                                          nearestCity: e?.value || '',
                                        })
                                      }
                                      value={
                                        cityOptions.find(o => o.value === this.state.currentMapItem.nearestCity)
                                      }
                                      options={cityOptions}
                                      isClearable
                                    />
                                    <h6 style={{ fontSize: 12 }}>Location:</h6>
                                    <textarea
                                      ref={(el) => (this.locationRef = el)}
                                      disabled={
                                        !this.state.editLocation ||
                                        this.state.unknownLocation
                                      }
                                      value={this.getLocationLine()}
                                      onChange={(e) =>
                                        this.locationChangeEvent(e)
                                      }
                                      onBlur={() =>
                                        this.setState({ editLocation: false })
                                      }
                                      rows={3}
                                      style={{ width: '90%' }}
                                    />
                                    &nbsp;&nbsp;
                                    {!this.state.editLocation &&
                                      !this.state.unknownLocation &&
                                      this.state.pinDropped && (
                                        <i
                                          className='pointer'
                                          onClick={() =>
                                            this.setState({
                                              editLocation: true,
                                            })
                                          }
                                        >
                                          <img
                                            src={
                                              window.location.origin +
                                              require('../../../../assets/edit.png')
                                            }
                                          />
                                        </i>
                                      )}
                                    {this.state.showLocationError && (
                                      <span>
                                        Location cannot have more than 100
                                        characters
                                      </span>
                                    )}
                                  </Card.Body>
                                </Card>
                              </Col>
                            </Row>
                          </Col>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  </Row>
                </Col>
              </Row>
            </div>
            <Navbar bg='light' style={{ marginBottom: '0px' }}>
              <Nav className='mr-auto'></Nav>
              <Button
                onClick={() => this.onSave()}
                disabled={this.state.saveDisabled}
                variant='success'
                size='sm'
              >
                Ok
              </Button>
              &nbsp;&nbsp;&nbsp;
              <Button size='sm' onClick={() => this.onCancel()} variant='danger'>
                Cancel
              </Button>
            </Navbar>
          </WindowPortal>
        )}
      </React.Fragment>
    );
  }
}

